export const api = {
    url: 'https://grafgruppe-api.grafgruppe.app/',
    // url: 'http://127.0.0.1:8000/',
    path: {
        default: 'api',
        storage: 'storage/',
        upload: 'files/file-upload'
    }
}
